import { Button, Spinner } from 'reactstrap';
import cx from 'classnames';

// when loading prop is true, add spinner on top of button
const ButtonWithLoading = ({ loading, className, ...rest }) => (
  <div className={cx('position-relative', className)}>
    <Button {...rest} />
    {loading && (
      <>
        {/* overlay: */}
        <div
          style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
            zIndex: 100,
          }}
        />

        {/* loading spinner */}
        <Spinner
          size="sm"
          color="muted"
          role="status"
          style={{
            position: 'absolute',
            top: 'calc(50% - 8px)',
            left: 'calc(50% - 8px)',
            borderWidth: '0.15em',
            zIndex: 101,
          }}
        />
      </>
    )}
  </div>
);

export default ButtonWithLoading;
